import { render, staticRenderFns } from "./UpdateNew.vue?vue&type=template&id=5ebff474&scoped=true&"
import script from "./UpdateNew.vue?vue&type=script&lang=js&"
export * from "./UpdateNew.vue?vue&type=script&lang=js&"
import style0 from "./UpdateNew.vue?vue&type=style&index=0&id=5ebff474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebff474",
  null
  
)

export default component.exports